import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { ContactCTA } from '../components/ContactCTA';
import { ServicesSection } from '../components/ServicesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmploymentSection } from '../components/EmploymentSection';
export function HomePage() {
  return <main className="bg-light min-h-screen" data-id="element-843">
      <HeroSection data-id="element-844" />
      <AboutSection data-id="element-845" />
      <WhyChooseUs data-id="element-846" />
      <ContactCTA data-id="element-847" />
      <ServicesSection limit={4} data-id="element-848" />
      <TestimonialsSection data-id="element-849" />
      <EmploymentSection data-id="element-850" />
    </main>;
}